import Cookie from 'js-cookie';
export { default as VueI18n } from 'vue-i18n';

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

var _cookieLocaleKey = 'lang';

var VueIntl = /*#__PURE__*/function () {
  function VueIntl() {
    _classCallCheck(this, VueIntl);

    this.i18n = null;
  }

  _createClass(VueIntl, [{
    key: "init",

    /**
     * @param i18n VueI18n instance, https://github.com/kazupon/vue-i18n
     */
    value: function init(i18n) {
      this.i18n = i18n;
    }
  }, {
    key: "t",
    value: function t() {
      if (this.i18n) {
        var _this$i18n;

        return (_this$i18n = this.i18n).t.apply(_this$i18n, arguments);
      }

      return (arguments.length <= 0 ? undefined : arguments[0]) || '';
    }
  }, {
    key: "$t",
    value: function $t() {
      return this.t.apply(this, arguments);
    }
  }]);

  return VueIntl;
}();

var intl = new VueIntl();
function getLocale(cookieLocaleKey) {
  if (cookieLocaleKey) _cookieLocaleKey = cookieLocaleKey;
  var locale = Cookie.get(_cookieLocaleKey);
  if (locale) return locale;
  locale = navigator.language || '';
  return locale.includes('en') ? 'en-US' : 'zh-CN';
}
function setLocale(locale, hardReload, cookieLocaleKey) {
  if (cookieLocaleKey) _cookieLocaleKey = cookieLocaleKey;
  intl.i18n.locale = locale;
  Cookie.set(_cookieLocaleKey, locale);
  if (hardReload) location.reload();
}

export { getLocale, intl, setLocale };
